var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg036Folder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2.99997C13.7342 2.99844 13.4787 3.10279 13.29 3.28997L11.59 4.99997H3C2.44772 4.99997 2 5.44769 2 5.99997V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V3.99997C22 3.44769 21.5523 2.99997 21 2.99997H14ZM20 19H4V6.99997H12C12.2658 7.00151 12.5213 6.89716 12.71 6.70997L14.41 4.99997H20V19Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg036Folder);
export default __webpack_public_path__ + "static/media/036-folder.04e948ff394cd1c13005946b76d21a47.svg";
export { ForwardRef as ReactComponent };